module.exports = __webpack_public_path__ + "static/img/qywx.8b922cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qywx.png
// module id = VDow
// module chunks = 0